// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const cottonee: PokeData = {
  "id": 546,
  "name": "cottonee",
  "height": 3,
  "weight": 6,
  "base_experience": 56,
  "types": [
    PokeType.GRASS,
    PokeType.FAIRY
  ],
  "api_moves": [
    "absorb",
    "mega-drain",
    "leech-seed",
    "growth",
    "razor-leaf",
    "solar-beam",
    "poison-powder",
    "stun-spore",
    "cotton-spore",
    "giga-drain",
    "charm",
    "sunny-day",
    "helping-hand",
    "endeavor",
    "energy-ball",
    "cotton-guard",
    "fairy-wind"
  ],
  "moves": [
    "razor-leaf",
    "solar-beam",
    "poison-powder",
    "stun-spore",
    "sunny-day",
    "energy-ball",
    "flower-rush",
    "hyper-voice",
    "overgrowth",
    "synthesis",
    "moonlight",
    "grassy-terrain",
    "play-rough"
  ],
  "evolution_chain": {
    "id": 278,
    "item": null,
    "species": [
      {
        "name": "cottonee",
        "order": 547,
        "types": [
          PokeType.GRASS,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "whimsicott",
        "order": 548,
        "types": [
          PokeType.GRASS,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": 546,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "sun-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 47.5,
    "speed": 66,
    "ability_power": 37
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
